'use client'
import { Button } from '@repo/design-system-cf/components/button'
import { useUserAuthModal } from '@repo/user-auth-dialog/user-auth-dialog-context'

export function SignUpButton({ children }: { children: React.ReactNode }) {
  const { openModal } = useUserAuthModal()
  const handleClick = () => {
    openModal()
  }

  return (
    <Button
      type="button"
      onClick={handleClick}
      className="text-16 font-bold uppercase"
      size="large"
    >
      {children}
    </Button>
  )
}
